import { PATH } from '@/shared/constants';

export const TERMS_TAB_LIST = [
  { name: '이용약관', path: PATH.TERMS_SERVICE },
  { name: '개인정보 처리방침', path: PATH.TERMS_PRIVACY },
  { name: '청소년보호정책', path: PATH.TERMS_YOUTH_PROTECTION },
];
